import { FC } from "react";
import { THeaderProps } from "./Header.config";
import { Container } from "../../layout";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderMenu } from "./HeaderMenu";
import { HeaderActions } from "./HeaderActions";

export const Header: FC<THeaderProps> = ({ menu }) => (
  <header data-component="Header" className="bg-sys-white">
    <Container className="relative h-16 flex justify-between items-center">
      <HeaderActions />
      <HeaderLogo />
      <HeaderMenu items={menu?.items} />
    </Container>
  </header>
);
